import { render, staticRenderFns } from "./ConnectionStats.vue?vue&type=template&id=193ef5c5&scoped=true"
import script from "./ConnectionStats.vue?vue&type=script&lang=js"
export * from "./ConnectionStats.vue?vue&type=script&lang=js"
import style0 from "./ConnectionStats.vue?vue&type=style&index=0&id=193ef5c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193ef5c5",
  null
  
)

export default component.exports